import React from 'react';

const Home: React.FC = () => {
    return <h3>Continue development</h3>;
};

export default Home;
